import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import AdditionalOrderInformationState from "@galarson/Store/AdditionalOrderInformation/AdditionalOrderInformationState";
const initialState: AdditionalOrderInformationState = {
    jobName: "",
    techName: ""
};

const reducer = {
    "Data/additionalOrderInformation/additionalOrderInformationLoads": (
        draft: Draft<AdditionalOrderInformationState>,
        action: {parameter: AdditionalOrderInformationState},
    ) => {
        draft.jobName = action.parameter.jobName;
        draft.techName = action.parameter.techName;
    },
    "Data/additionalOrderInformation/additionalOrderInformationClear": (
        draft: Draft<AdditionalOrderInformationState>,
        action: {parameter: AdditionalOrderInformationState},
    ) => {
        draft.jobName = "";
        draft.techName = "";
    }
};



export default createTypedReducerWithImmer(initialState, reducer);
